import { FormHelpers } from 'utility/form-helpers'
import { SideCart } from '.'
import { WarningIcon, CheckCircleHollowIcon } from '../icons'
import { Toasts } from '../components/toasts'
//import { Search } from '../components/search'

const el = {
  addToCartForms: document.querySelectorAll<HTMLFormElement>('.add-to-cart-form'),
  addStockNotificationForms: document.querySelectorAll<HTMLFormElement>(
    '.addStockNotification-form'
  ),
  cartButton: document.querySelector<HTMLButtonElement>('#cart-button'),
  sideCart: document.querySelector<HTMLDivElement>('.side-cart'),
}

export const Cart = {
  init: () => {
    el.addStockNotificationForms.forEach((target) =>
      target.addEventListener('submit', Cart.addStockNotification)
    )
    el.addToCartForms.forEach((target) =>
      target.addEventListener('submit', Cart.addToCart)
    )
    Cart.activeCartItems({ sideCartOnly: false })
  },

  addStockNotification: async (e: Event & { target: HTMLFormElement }) => {
    e.preventDefault()
    console.log('error')
    FormHelpers.submitForm({
      form: e.target,
      buttons: [e.target.querySelector<HTMLButtonElement>('button[type="submit"]')],
      onSuccess: (message) => {
        // if cart item is a cross sell product we reload the page
        Toasts.addToast({
          title: 'Netfang skráð',
          text: message.message,
          icon: CheckCircleHollowIcon(),
        })

        e.target.style.display = 'none';
        const messageElement = e.target.parentElement.querySelector<HTMLDivElement>('.stockNotification-card-message');
        if (messageElement) {
          messageElement.classList.add('display');
        }
      },
      onError: (message) => {

        Toasts.addToast({
          title: 'Villa kom upp!',
          text: message,
          icon: WarningIcon(),
        })
      },
    })
  },

  addToCart: async (e: Event & { target: HTMLFormElement }) => {
    e.preventDefault()
    FormHelpers.submitForm({
      form: e.target,
      buttons: [e.target.querySelector<HTMLButtonElement>('button[type="submit"]')],
      onSuccess: () => {
        // if side cart is already open we have to trigger update manually
        if (el.sideCart && el.sideCart.classList.contains('side-cart--open')) {
          //Search.onClose()
          SideCart.fetchSideCart()
          return
        }

        // if cart item is a cross sell product we reload the page
        if (e.target.classList.contains('horizontal-product-card__form')) {
          window.location.reload()
          return
        }

        el.cartButton && el.cartButton.click()
      },
      onError: (message) =>
        Toasts.addToast({
          title: 'Villa kom upp!',
          text: message || 'Ekki tókst að bæta vöru við í körfu.',
          icon: WarningIcon(),
        }),
    })
  },

  activeCartItems: ({ sideCartOnly = false }) => {
    const cartItems = document.querySelectorAll<HTMLDivElement>(
      sideCartOnly ? '.cart-item--side' : '.cart-item'
    )

    cartItems.forEach((cartItem) => {
      const updateQuantityForm = cartItem.querySelector<HTMLFormElement>(
        '.update-quantity-form'
      )
      const removeOrderlineForm = cartItem.querySelector<HTMLFormElement>(
        '.remove-orderline-form'
      )

      if (removeOrderlineForm)
        removeOrderlineForm.addEventListener('submit', Cart.onRemoveOrderlineSubmit)

      if (!updateQuantityForm) return

      updateQuantityForm.addEventListener('submit', Cart.onUpdateQuantitySubmit)
      const quantityInput =
        updateQuantityForm.querySelector<HTMLInputElement>('.stepper__input')
      const incrementButton = updateQuantityForm.querySelector<HTMLButtonElement>(
        '.action-button--increment'
      )
      const decrementButton = updateQuantityForm.querySelector<HTMLButtonElement>(
        '.action-button--decrement'
      )

      if (!quantityInput || !incrementButton || !decrementButton) return

      incrementButton.addEventListener('click', () =>
        Cart.onIncrement({
          input: quantityInput,
          form: updateQuantityForm,
        })
      )
      decrementButton.addEventListener('click', () =>
        Cart.onDecrement({
          input: quantityInput,
          form: updateQuantityForm,
        })
      )
    })
  },

  onInputBlur: ({ input, form }: { input: HTMLInputElement; form: HTMLFormElement }) => {
    const { oldvalue: oldValue = '' } = input.dataset
    const currentValue = input.value
    if (oldValue === currentValue) return

    // set input value to old value if value is zero
    try {
      if (parseInt(currentValue) === 0) {
        input.value = oldValue
        return
      }
    } catch (_) {
      /* */
    }

    Cart.changeQuantity({ form, type: 'update-quantity' })
  },

  onUpdateQuantitySubmit: (e: Event & { target: HTMLFormElement }) => {
    e.preventDefault()
    Cart.changeQuantity({
      form: e.target,
      type: 'update-quantity',
    })
  },

  onRemoveOrderlineSubmit: (e: Event & { target: HTMLFormElement }) => {
    e.preventDefault()
    Cart.changeQuantity({
      form: e.target,
      type: 'remove-orderline',
    })
  },

  changeQuantity: ({
    form,
    type = 'update-quantity',
  }: {
    form: HTMLFormElement
    type: 'update-quantity' | 'remove-orderline'
  }) => {
    const { withinsidecart = 'false' } = form.dataset
    const isWithinSideCart = withinsidecart.toLowerCase() === 'true'
    const input = form.querySelector<HTMLInputElement>('.stepper__input')

    const targetClasses = [
      '.cart-item .update-quantity-form .action-button--decrement',
      '.cart-item .update-quantity-form .action-button--increment',
      '.cart-item .update-quantity-form .stepper__input',
      '.cart-item .remove-orderline-form [type="submit"]',
    ].join(', ')
    const elementsToDisable = document.querySelectorAll<
      HTMLButtonElement | HTMLInputElement
    >(targetClasses)

    FormHelpers.submitForm({
      form,
      buttons: Array.from(elementsToDisable),
      showSpinner: false,
      onSuccess: ({ message, ...data }) => {
        if (isWithinSideCart) {
          SideCart.updateSideCart(data)
          return
        }
        window.location.reload()
      },
      onError: (message = '') => {
        Toasts.addToast({
          title: 'Villa kom upp!',
          text: message
            ? message
            : type === 'update-quantity'
            ? 'Ekki tókst að breyta vörufjölda.'
            : 'Ekki tókst að eyða vöru úr körfu.',
          icon: WarningIcon(),
        })

        // set input value to old value if request fails
        if (!input || type !== 'update-quantity') return
        const { oldvalue: oldValue = '' } = input.dataset
        if (!oldValue) return
        input.value = oldValue
      },
    })
  },

  onIncrement: ({ input, form }: { input: HTMLInputElement; form: HTMLFormElement }) => {
    try {
      const oldValue = input.value
      input.value = `${parseInt(oldValue) + 1}`
      Cart.changeQuantity({ form, type: 'update-quantity' })
    } catch (_) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text: 'Ekki tókst að breyta vörufjölda.',
        icon: WarningIcon(),
      })
    }
  },

  onDecrement: ({ input, form }: { input: HTMLInputElement; form: HTMLFormElement }) => {
    try {
      const oldValue = parseInt(input.value)
      if (oldValue <= 1) return
      input.value = `${oldValue - 1}`
      Cart.changeQuantity({ form, type: 'update-quantity' })
    } catch (_) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text: 'Ekki tókst að breyta vörufjölda.',
        icon: WarningIcon(),
      })
    }
  },
}
